/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventManagementCreateEventRequest } from '../models/EventManagementCreateEventRequest';
import type { EventManagementCreateEventResponseApiRespoonse } from '../models/EventManagementCreateEventResponseApiRespoonse';
import type { EventManagementCreateSecondEventRequest } from '../models/EventManagementCreateSecondEventRequest';
import type { EventManagementCreateSecondEventResponseApiRespoonse } from '../models/EventManagementCreateSecondEventResponseApiRespoonse';
import type { EventManagementDeleteEventRequest } from '../models/EventManagementDeleteEventRequest';
import type { EventManagementDeleteEventResponseApiRespoonse } from '../models/EventManagementDeleteEventResponseApiRespoonse';
import type { EventManagementEditEventRequest } from '../models/EventManagementEditEventRequest';
import type { EventManagementEditEventResponseApiRespoonse } from '../models/EventManagementEditEventResponseApiRespoonse';
import type { EventManagementExportZipRequest } from '../models/EventManagementExportZipRequest';
import type { EventManagementExportZipResponseApiRespoonse } from '../models/EventManagementExportZipResponseApiRespoonse';
import type { EventManagementGenerateSharedPreviewUrlRequest } from '../models/EventManagementGenerateSharedPreviewUrlRequest';
import type { EventManagementGenerateSharedPreviewUrlResponseApiRespoonse } from '../models/EventManagementGenerateSharedPreviewUrlResponseApiRespoonse';
import type { EventManagementGenerateZipCertRequest } from '../models/EventManagementGenerateZipCertRequest';
import type { EventManagementGenerateZipCertResponseApiRespoonse } from '../models/EventManagementGenerateZipCertResponseApiRespoonse';
import type { EventManagementGenerateZipImageRequest } from '../models/EventManagementGenerateZipImageRequest';
import type { EventManagementGenerateZipImageResponseApiRespoonse } from '../models/EventManagementGenerateZipImageResponseApiRespoonse';
import type { EventManagementGetMemberByEventNumberRequest } from '../models/EventManagementGetMemberByEventNumberRequest';
import type { EventManagementGetMemberByEventNumberResponseApiRespoonse } from '../models/EventManagementGetMemberByEventNumberResponseApiRespoonse';
import type { EventManagementGetTokenRequest } from '../models/EventManagementGetTokenRequest';
import type { EventManagementGetTokenResponseApiRespoonse } from '../models/EventManagementGetTokenResponseApiRespoonse';
import type { EventManagementListEventEntryRequest } from '../models/EventManagementListEventEntryRequest';
import type { EventManagementListEventEntryResponseApiRespoonse } from '../models/EventManagementListEventEntryResponseApiRespoonse';
import type { EventManagementListEventForSelectRequest } from '../models/EventManagementListEventForSelectRequest';
import type { EventManagementListEventForSelectResponseApiRespoonse } from '../models/EventManagementListEventForSelectResponseApiRespoonse';
import type { EventManagementListEventRequest } from '../models/EventManagementListEventRequest';
import type { EventManagementListEventResponseApiRespoonse } from '../models/EventManagementListEventResponseApiRespoonse';
import type { EventManagementPrintResultItemListRequest } from '../models/EventManagementPrintResultItemListRequest';
import type { EventManagementPrintResultItemListResponseApiRespoonse } from '../models/EventManagementPrintResultItemListResponseApiRespoonse';
import type { EventManagementReadEventCsvRequest } from '../models/EventManagementReadEventCsvRequest';
import type { EventManagementReadEventCsvResponseApiRespoonse } from '../models/EventManagementReadEventCsvResponseApiRespoonse';
import type { EventManagementReceptRequest } from '../models/EventManagementReceptRequest';
import type { EventManagementReceptResponseApiRespoonse } from '../models/EventManagementReceptResponseApiRespoonse';
import type { EventManagementSettingAllSoldRequest } from '../models/EventManagementSettingAllSoldRequest';
import type { EventManagementSettingAllSoldResponseApiRespoonse } from '../models/EventManagementSettingAllSoldResponseApiRespoonse';
import type { EventManagementSettingEventCheckinRequest } from '../models/EventManagementSettingEventCheckinRequest';
import type { EventManagementSettingEventCheckinResponseApiRespoonse } from '../models/EventManagementSettingEventCheckinResponseApiRespoonse';
import type { EventManagementSettingEventEditRequest } from '../models/EventManagementSettingEventEditRequest';
import type { EventManagementSettingEventEditResponseApiRespoonse } from '../models/EventManagementSettingEventEditResponseApiRespoonse';
import type { EventManagementSettingEventReDrawRequest } from '../models/EventManagementSettingEventReDrawRequest';
import type { EventManagementSettingEventReDrawResponseApiRespoonse } from '../models/EventManagementSettingEventReDrawResponseApiRespoonse';
import type { EventManagementSettingEventRequest } from '../models/EventManagementSettingEventRequest';
import type { EventManagementSettingEventResponseApiRespoonse } from '../models/EventManagementSettingEventResponseApiRespoonse';
import type { EventManagementViewEventRequest } from '../models/EventManagementViewEventRequest';
import type { EventManagementViewEventResponseApiRespoonse } from '../models/EventManagementViewEventResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EventManagementEventService {

    /**
     * イベント一覧
     * @param requestBody
     * @returns EventManagementListEventResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEvent(
        requestBody: EventManagementListEventRequest,
    ): CancelablePromise<EventManagementListEventResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント結果印刷用データ取得
     * @param requestBody
     * @returns EventManagementPrintResultItemListResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventPrintResultItemList(
        requestBody: EventManagementPrintResultItemListRequest,
    ): CancelablePromise<EventManagementPrintResultItemListResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/print-result-item-list',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * list event for select box
     * @param requestBody
     * @returns EventManagementListEventForSelectResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventListForSelect(
        requestBody: EventManagementListEventForSelectRequest,
    ): CancelablePromise<EventManagementListEventForSelectResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/list-for-select',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベントの新規登録
     * @param requestBody
     * @returns EventManagementCreateEventResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventCreate(
        requestBody: EventManagementCreateEventRequest,
    ): CancelablePromise<EventManagementCreateEventResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベントの更新
     * @param requestBody
     * @returns EventManagementEditEventResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventEdit(
        requestBody: EventManagementEditEventRequest,
    ): CancelablePromise<EventManagementEditEventResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/event/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベントの削除
     * @param requestBody
     * @returns EventManagementDeleteEventResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventDelete(
        requestBody: EventManagementDeleteEventRequest,
    ): CancelablePromise<EventManagementDeleteEventResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/event/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント詳細
     * @param requestBody
     * @returns EventManagementViewEventResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventView(
        requestBody: EventManagementViewEventRequest,
    ): CancelablePromise<EventManagementViewEventResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/view',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント抽選結果登録
     * @param requestBody
     * @returns EventManagementSettingEventResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSetting(
        requestBody: EventManagementSettingEventRequest,
    ): CancelablePromise<EventManagementSettingEventResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/setting',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント抽選結果登録 チェックインテーブル更新
     * @param requestBody
     * @returns EventManagementSettingEventCheckinResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSettingCheckin(
        requestBody: EventManagementSettingEventCheckinRequest,
    ): CancelablePromise<EventManagementSettingEventCheckinResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/setting-checkin',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント抽選結果登録 更新
     * @param requestBody
     * @returns EventManagementSettingEventEditResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSettingEdit(
        requestBody: EventManagementSettingEventEditRequest,
    ): CancelablePromise<EventManagementSettingEventEditResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/setting-edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント抽選結果登録 再抽選
     * @param requestBody
     * @returns EventManagementSettingEventReDrawResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSettingReDraw(
        requestBody: EventManagementSettingEventReDrawRequest,
    ): CancelablePromise<EventManagementSettingEventReDrawResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/setting-re-draw',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント抽選結果登録 すべて成約済み
     * @param requestBody
     * @returns EventManagementSettingAllSoldResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSettingAllSold(
        requestBody: EventManagementSettingAllSoldRequest,
    ): CancelablePromise<EventManagementSettingAllSoldResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/setting-all-sold',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント来場者一覧
     * @param requestBody
     * @returns EventManagementReceptResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventRecept(
        requestBody: EventManagementReceptRequest,
    ): CancelablePromise<EventManagementReceptResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/recept',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベントcsv読み込み
     * @param requestBody
     * @returns EventManagementReadEventCsvResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventCsv(
        requestBody: EventManagementReadEventCsvRequest,
    ): CancelablePromise<EventManagementReadEventCsvResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/csv',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ZIPファイルのダウンロード
     * @param requestBody
     * @returns EventManagementExportZipResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventExportZip(
        requestBody: EventManagementExportZipRequest,
    ): CancelablePromise<EventManagementExportZipResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/export-zip',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 写真生成実行
     * @param requestBody
     * @returns EventManagementGenerateZipImageResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventGenerateZipImage(
        requestBody: EventManagementGenerateZipImageRequest,
    ): CancelablePromise<EventManagementGenerateZipImageResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/generate-zip-image',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 証明書生成実行
     * @param requestBody
     * @returns EventManagementGenerateZipCertResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventGenerateZipCert(
        requestBody: EventManagementGenerateZipCertRequest,
    ): CancelablePromise<EventManagementGenerateZipCertResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/generate-zip-cert',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get token
     * @param requestBody
     * @returns EventManagementGetTokenResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventConnectSocketUrl(
        requestBody: EventManagementGetTokenRequest,
    ): CancelablePromise<EventManagementGetTokenResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/connect-socket-url',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get entries
     * @param requestBody
     * @returns EventManagementListEventEntryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventEntries(
        requestBody: EventManagementListEventEntryRequest,
    ): CancelablePromise<EventManagementListEventEntryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/entries',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 共有プレビューURL生成
     * @param requestBody
     * @returns EventManagementGenerateSharedPreviewUrlResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventGenerateSharedPreviewUrl(
        requestBody: EventManagementGenerateSharedPreviewUrlRequest,
    ): CancelablePromise<EventManagementGenerateSharedPreviewUrlResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/generate-shared-preview-url',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベントナンバーからメンバー情報を取得する
     * @param requestBody
     * @returns EventManagementGetMemberByEventNumberResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventGetMemberByEventNumber(
        requestBody: EventManagementGetMemberByEventNumberRequest,
    ): CancelablePromise<EventManagementGetMemberByEventNumberResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/get-member-by-event-number',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 延長戦イベントを作成
     * @param requestBody
     * @returns EventManagementCreateSecondEventResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventCreateSecondEvent(
        requestBody: EventManagementCreateSecondEventRequest,
    ): CancelablePromise<EventManagementCreateSecondEventResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event/create-second-event',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
